import React from 'react';

import ChartInsight from '../../components/ChartInsight';

export const ProfileInsightDetail = ({ data }) => (
    <div>
        <ChartInsight {...data} />
    </div>
);

export default ProfileInsightDetail;


// WEBPACK FOOTER //
// ./src/pages/details/ProfileInsightDetail.js